import { Download, FileText, Image as ImageIcon, QrCode, Shapes } from "lucide-react";
import { agents } from "../data/agents";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/cards`;

export const CardQrSection = () => (
  <section className="mandate-qr-section" data-testid="mandate-qr-section">
    <div className="mandate-section-heading">
      <div>
        <p className="mandate-overline">Carte de visite digitale</p>
        <h2>QR codes prêts pour l’imprimeur</h2>
      </div>
    </div>
    <div className="mandate-qr-grid">
      {Object.values(agents).map((agent) => (
        <article key={agent.slug} data-testid={`mandate-qr-card-${agent.slug}`}>
          <img
            src={`${API_BASE}/${agent.slug}/qr.png?size=900`}
            alt={`QR code de la carte de ${agent.firstName} ${agent.lastName}`}
            loading="lazy"
          />
          <div>
            <strong>
              {agent.firstName} {agent.lastName}
            </strong>
            <small>
              Lien court imprimé : pimpmyplace.fr/c/{agent.shortCode} · redirige vers /{agent.slug} avec le
              suivi de campagne (utm_source=businesscard).
            </small>
            <div className="mandate-qr-actions">
              <a
                href={`${API_BASE}/${agent.slug}/qr.pdf`}
                data-testid={`mandate-qr-pdf-${agent.slug}`}
              >
                <FileText size={14} /> PDF imprimeur
              </a>
              <a
                href={`${API_BASE}/${agent.slug}/qr.png?size=3000`}
                data-testid={`mandate-qr-png-${agent.slug}`}
              >
                <ImageIcon size={14} /> PNG 3000 px
              </a>
              <a
                href={`${API_BASE}/${agent.slug}/qr.svg`}
                data-testid={`mandate-qr-svg-${agent.slug}`}
              >
                <Shapes size={14} /> SVG vectoriel
              </a>
              <a
                href={`${API_BASE}/${agent.slug}/qr.png?campaign=salon&size=3000`}
                data-testid={`mandate-qr-campaign-${agent.slug}`}
              >
                <QrCode size={14} /> Variante « salon »
              </a>
            </div>
            <span className="mandate-qr-hint">
              <Download size={12} /> Taille d’impression minimale : 20 × 20 mm. Correction d’erreur H (30 %).
            </span>
          </div>
        </article>
      ))}
    </div>
  </section>
);
